<template>
  <footer class="footer">
    <div class="footer-content">
      <div class="footer-column">
        <h4>关于我们</h4>
        <!-- <p>这里是关于我们网站的一些信息。</p> -->
        <p>版权所有 &copy; {{ currentYear }} 上海星圆星科技有限公司. 保留所有权利。</p>
      </div>
      <div class="footer-column">
        <h4>快速链接</h4>
        <ul>
          <li><a href="/">首页</a></li>
          <li><a href="http://tiyuai.net/wuyeyinsi.html">隐私政策</a></li>
        </ul>
      </div>
      <!-- <div class="footer-column">
        <h4>社交媒体</h4>
        <ul>
          <li><a href="https://facebook.com" target="_blank">Facebook</a></li>
          <li><a href="https://twitter.com" target="_blank">Twitter</a></li>
          <li><a href="https://instagram.com" target="_blank">Instagram</a></li>
          <li><a href="https://linkedin.com" target="_blank">LinkedIn</a></li>
        </ul>
      </div> -->
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer',
  data() {
    return {
      currentYear: new Date().getFullYear(),
    };
  },
};
</script>

<style scoped>
.footer {
  background-color: #333;
  color: #fff;
  padding: 20px 0;
  text-align: center;
}

.footer-content {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
}

.footer-column {
  flex: 1;
  min-width: 250px;
  margin: 0 20px;
}

.footer-column h4 {
  margin-bottom: 15px;
  font-size: 18px;
  color: #ddd;
}

.footer-column ul {
  list-style: none;
  padding: 0;
}

.footer-column ul li {
  margin-bottom: 10px;
}

.footer-column ul li a {
  color: #fff;
  text-decoration: none;
}

.footer-column ul li a:hover {
  text-decoration: underline;
}
</style>